export default {
  component: {
    LOGOUT_POPUP: 'logout_popup',
    COMPANY_SECTION: 'company_section',
    LOGIN: 'login',
    LANDING_HEADER: 'landing_header',
    SECTION_LIST: 'section_list',
    SETTINGS: 'settings',
    ORDER_HISTORY: 'order_history',
    CHOOSE_PERIOD_INTERVAL: 'choose_period_interval',
    ORDER_LIST: 'order_list',
    CHECKOUT: 'checkout',
    QUOTAION_TERMS_AND_CONDITIONS: 'term_condition',
    THANK_YOU_PAGE: 'thankyou',
    SALE_HEADER: 'sale_header',
    IMEI_DOWNLOAD: 'sale_download',
    IMEI_UPLOAD: 'imei_upload',
    IMEI_SCAN: 'imei_scan',
    IMEI_MANUAL: 'imei_scan_manual_input',
    IMEI_CONFIRM: 'imei_scan_confirmation',
    IMEI_LIST: 'sale_list',
    IMEI_DETAIL: 'sale_detail',
    IMEI_UPLOAD_CASHBACK: 'upload_invoice',
    NOTIFICATION: 'notification'
  },
  label: {
    LOGIN: 'Login',
    REGISTER: 'Register',
    FORGET_PASSWORD: 'Forget Password',
    TERM_AND_CONDITION: 'Term & Condition',
    PRIVACY_POLICY: 'Privacy Policy',
    LOGOUT: 'Logout',
    BACK: 'Back',
    REDEEM_POINT: 'Redeem Point',
    SEE_MISSION: 'See Mission',
    SETTINGS: 'Setting',
    ALLOCATE_POINT: 'Tukar Poin',
    VIEW_MISSION: 'Lihat Misi',
    VIEW_CREDIT_NOTE: 'Lihat Credit Note',
    VIEW_QUOTATION_DETAIL: 'Lihat Rincian',
    ALLOW_NOTIIFICATION: 'Allow Notifications',
    DENY_NOTIFICATION: 'Deny Notifications',
    SECTION: {
      companyInfo: 'Company Info',
      legalDocs: 'Legal Document',
      sellerInfo: 'Additional Info', // check
      ownerDetails: 'Director Info / PIC Info',
      supportDocs: 'Registration Form'
    },
    IMEI: {
      DOWNLOAD: 'Download',
      UPLOAD: 'upload',
      MANUAL: 'Isi manual',
      UPLOAD_TEMPLATE: 'pakai template',
      MANUAL_CLICK: 'Lanjut',
      MANUAL_CONTINUE: 'Lanjut',
      MANUAL_CANCEL: 'Batal'
    },
    CASHBACK: {
      CLAIM: 'Klaim',
      CLAIM_FOOTER: 'Klaim cashback'
    },
    DOWNLOAD: 'Download',
    ORDER_STATUS: {
      QUOTATION_CREATED: 'Diproses',
      QUOTATION_PROCESSED: 'Menunggu persetujuan',
      QUOTATION_REJECTED: 'Ditolak',
      QUOTATION_EXPIRED: 'Kedaluwarsa',
      QUOTATION_APPROVED: 'Disetujui',
      PO_CREATED: 'Disetujui',
      IN_PACKING: 'Dalam pengemasan',
      IN_DELIVERY: 'Dalam pengiriman',
      DELIVERED: 'Sampai',
      ORDER_COMPLETED: 'Selesai'
    },
    DASHBOARD: {
      UPLOAD: 'Upload IMEI',
      SCAN: 'Scan IMEI',
      DOWNLOAD: 'Penjualan'
    },
    LIST_ALL_DATA: 'Semua',
    DETAIL_ITEM: 'Detail Item',
    SALE_DETAIL: 'Detail Sale£',
    CHANGE_ADDRESS: {
      EDIT: 'Ubah alamat',
      CANCEL: 'Kembali',
      SAVE: 'Simpan'
    },
    PROCEED_CHECKOUT: 'Ajukan',
    QUOTATION_ACKNOWLEDGEMENT: {
      CHECKED: 'Checked',
      UNCHECKED: 'Unchecked'
    },
    THANK_YOU: {
      CONTINUE: 'Belanja lagi',
      CHECK: 'Cek status pesanan'
    }
  },
  error_type: {
    ERROR_TYPE_HANDLE_UNSPECIFIED: 'unspecified',
    ERROR_TYPE_HANDLE: '1'
  },
  origin_screen: {
    landingPage: 'dealer-landing',
    login: 'dealer-login',
    profile: 'dealer-setting',
    order: 'dealer-order',
    homePage: 'dealer-homepage',
    catalog: 'dealer-catalog',
    rewards: 'dealer-sale',
    rewardsDetail: 'dealer-sale'
  }
}
